import {
  ACTION_AUTH__REQUEST,
  ACTION_AUTH__SUCCESS,
  ACTION_AUTH__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_AUTH__REQUEST:
    case ACTION_AUTH__SUCCESS:
      return null;

    case ACTION_AUTH__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
